import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "invalid-feedback" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_7 = {
  for: "type-increment",
  class: "flex items-center gap-3 cursor-pointer"
}
const _hoisted_8 = {
  for: "type-decrement",
  class: "flex items-center gap-3 cursor-pointer"
}
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { class: "container-btn-action" }

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import { Form, Field } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, getCurrentInstance, ref, computed } from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull } from 'lodash'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import RadioButton from 'primevue/radiobutton'

const moduleStore = 'hjpTable'
const endpoint = '/talent/v1/penaltyAdjustmentCategories'

export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataForm = ref()
const idPrams = computed(() => store.state[moduleStore].modal?.data?.id)

const getAdjustmentType = (type?: string | null) => {
  if (type?.toLowerCase() === 'increment') {
    return 'Increment'
  }
  if (type?.toLowerCase() === 'decrement') {
    return 'Decrement'
  }
  return null
}

const initialValues = {
  Name: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.name : '',
  Code: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.code : '',
  Description: store.state.hjpTable.modal.data
    ? store.state.hjpTable.modal.data.description ?? store.state.hjpTable.modal.data.Description
    : '',
  Type: getAdjustmentType(store.state.hjpTable.modal.data?.adjustmentType),
  IsActive: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.isActive : true
}

const schema = Yup.object().shape({
  Name: Yup.string()
    .required('Nama Kategori Denda harus diisi!')
    .min(3, 'Nama Kategori Denda minimal 3 karakter')
    .max(100, 'Nama Kategori Denda tidak boleh melebihi 100 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Kategori Denda tidak boleh hanya menggunakan spasi')
    .matches(rgxExp.noSpecialChar, 'Nama Kategori Denda tidak boleh mengandung karakter spesial')
    .test('unique-name', 'Nama Kategori Denda sudah digunakan', async (val) => {
      if (!val) return true
      if (val.length > 2) {
        try {
          const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
            search: val,
            filterField: ['name']
          })}`)
          // const filterResult = res.result.data.filter((x: any) => x.name === val)
          const filterResult = res.result.data
          // console.log('filterResult', [filterResult, filterResult.length, res.result.data, val, initialValues.Name, val === initialValues.Name])
          if (idPrams.value) {
            return filterResult.length === 0 || val === initialValues.Name
          } return filterResult.length === 0
        } catch (error) {
          return false
        }
      }
      return true
    }),
  Code: Yup.string()
    .required('Kode Kategori Denda harus diisi!')
    .min(3, 'Kode Kategori Denda minimal 3 karakter')
    .max(100, 'Kode Kategori Denda maksimal 100 karakter')
    .matches(rgxExp.notPrefixSpace, 'Kode Kategori Denda tidak boleh hanya menggunakan spasi')
    .matches(rgxExp.notOnlySpecialChar, 'Kode Kategori Denda tidak boleh menggunakan spasi dan karakter spesial')
    .test('unique-code', 'Kode Kategori Denda sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['code']
        })}`)
        // console.log('res', res)
        const filterResult = res.result.data.filter((x: any) => x.code.toLowerCase() === val.toLowerCase())
        // console.log('filterCode', filterResult)
        if (idPrams.value) {
          return filterResult.length === 0 || val.toLowerCase() === initialValues.Code.toLowerCase()
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Type: Yup.string()
    .oneOf(['Increment', 'Decrement'], 'Pilih salah satu tipe denda!')
    .required('Tipe Denda harus diisi!'),
  Description: Yup.string()
    // .notRequired('Keterangan harus diisi!')
    .notRequired()
    .matches(rgxExp.notPrefixSpace, 'Keterangan tidak boleh hanya menggunakan spasi.')
    .min(5, 'Keterangan minimal 5 karakter')
    .max(300, 'Keterangan maksimal 300 karakter')
})

const onSubmit = (values: any) => {
  console.log('masukk submit', values)
  // eslint-disable-next-line no-use-before-define
  processSubmit(values)
}

const hideSidebar = () => {
  store.dispatch('setShowModal', false)
  store.dispatch('setTitleFormSidebar', null)
}

const changeOk = (val: any) => {
  console.log('valll', val)
}

const onSearchOption = (search: any, loading: any) => {
  console.log('search', search)
}

const onSelectedBank = (selected: any) => {
  console.log('selected', selected)
}

const processSubmit = async (val: any) => {
  store.dispatch('showLoading')
  console.log('val', val)

  if (isNull(store.state.hjpTable.modal.data)) {
    dataForm.value = {
      name: val.Name,
      code: val.Code,
      description: val.Description,
      adjustmentType: val.Type,
      isActive: val.IsActive
    }
  } else {
    dataForm.value = {
      id: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.id : '',
      name: val.Name,
      code: val.Code,
      description: val.Description,
      adjustmentType: val.Type,
      isActive: val.IsActive,
    }
  }
  console.log('dataForm', dataForm.value)
  const response = isNull(store.state.hjpTable.modal.data) ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, store.state.hjpTable.modal.data.id, dataForm.value)
  console.log('response', response)
  if (!response.error) {
    $toast.add({
      severity: 'success',
      summary: isNull(store.state.hjpTable.modal.data) ? 'Data Kategori Berhasil Ditambahkan' : 'Data Kategori Berhasil Diubah',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data kategori denda telah berhasil ditambahkan ke dalam sistem' : 'Data kategori denda di sistem telah berhasil diperbaruhi',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    $toast.add({
      severity: 'error',
      summary: isNull(store.state.hjpTable.modal.data) ? 'Data Kategori Gagal Ditambahkan' : 'Data Kategori Gagal Diubah',
      detail: response.message,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('setShowModal', false)
  store.dispatch('setReloadDataTable', true)
  store.dispatch('setTitleFormSidebar', null)
  store.dispatch('hideLoading')
}

onMounted(() => {
  console.log('store', store.state)
  let titleForm = 'Tambah'
  if (store.state.hjpTable.modal.data) {
    titleForm = 'Edit'
  }
  store.dispatch('setTitleFormSidebar', `${titleForm} Kategori Denda`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "label-text required" }, "Nama Kategori Denda", -1)),
          _createVNode(_unref(Field), { name: "Name" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Name,
                "onUpdate:modelValue": ($event: any) => ((values.Name) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                placeholder: "Nama Kategori Denda",
                autocomplete: "off",
                maxlength: 100
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_2, _toDisplayString(errors.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", {
            for: "code",
            class: "label-text required"
          }, "Kode Kategori Denda", -1)),
          _createVNode(_unref(Field), { name: `Code` }, {
            default: _withCtx(({ handleChange, handleBlur, field }) => [
              _createVNode(_unref(InputText), _mergeProps({ id: "code" }, field, {
                "aria-describedby": "code-help",
                class: `input-primary ${errors.Code ? 'input-invalid' : ''}`,
                placeholder: "Kode Kategori Denda",
                onChange: handleChange,
                onBlur: handleBlur,
                maxlength: "5",
                style: {"text-transform":"uppercase"}
              }), null, 16, ["class", "onChange", "onBlur"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_4, _toDisplayString(errors.Code), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label-text required" }, "Tipe Denda", -1)),
          _createVNode(_unref(Field), { name: "Type" }, {
            default: _withCtx(({ value, handleChange }) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, [
                  _createVNode(_unref(RadioButton), {
                    inputId: "type-increment",
                    name: "Type",
                    value: "Increment",
                    modelValue: value,
                    "onUpdate:modelValue": handleChange
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "Surplus (+)", -1))
                ]),
                _createElementVNode("label", _hoisted_8, [
                  _createVNode(_unref(RadioButton), {
                    inputId: "type-decrement",
                    name: "Type",
                    value: "Decrement",
                    modelValue: value,
                    "onUpdate:modelValue": handleChange
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "Pengurang (-)", -1))
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, _toDisplayString(errors.Type), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label-text" }, "Keterangan", -1)),
          _createVNode(_unref(Field), {
            name: "Description",
            as: "textarea",
            placeholder: "Tulis Keterangan",
            class: "input-primary"
          }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(Textarea), _mergeProps(field, {
                modelValue: values.Description,
                "onUpdate:modelValue": ($event: any) => ((values.Description) = $event),
                id: "description",
                autocomplete: "nope",
                autoResize: true,
                ref: "descriptionRef",
                rows: "3",
                onChange: handleChange,
                onBlur: handleBlur
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_11, _toDisplayString(errors.Description), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("Kembali")
            ])),
            _: 1,
            __: [7]
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Simpan")
            ])),
            _: 1,
            __: [8]
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})